import React from 'react';
import { TargetIcon, TelescopeIcon, GemIcon } from 'lucide-react';
import { VALUES } from '../data/site';
import { SectionHeading } from './SectionHeading';
import { Reveal } from './Reveal';
export function MissionVisionValues() {
  return <section id="valores" className="bg-haze py-24 sm:py-32" data-id="element-187" data-mp="3fum3wn7hgogk">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-188" data-mp="3aw2hymsw3co7">
        <Reveal data-id="element-189" data-mp="3axlx2a2t7hoe">
          <SectionHeading eyebrow="Nuestra esencia" title="Misión, visión y valores" description="Lo que nos guía todos los días, desde el primer saludo en el salón hasta la última entrega de la jornada." align="center" data-id="element-190" data-mp="cddoea08a0p0" />
        </Reveal>

        <div className="mt-14 grid gap-6 lg:grid-cols-2" data-id="element-191" data-mp="3tu52aoahslfo">
          <Reveal delay={0.05} data-id="element-192" data-mp="3ttlpflzp8n8i">
            <article className="h-full rounded-4xl border border-black/5 bg-white p-8 sm:p-10 shadow-soft" data-id="element-193" data-mp="v44sox5cz0wj">
              <span className="inline-flex h-14 w-14 items-center justify-center rounded-2xl border border-brand/25 bg-brand-light text-brand" data-id="element-194" data-mp="qdoh7il3lpct">
                <TargetIcon className="h-7 w-7" strokeWidth={1.25} aria-hidden="true" data-id="element-195" data-mp="1wvimo3frcgif" />
              </span>
              <h3 className="mt-7 text-2xl sm:text-3xl font-semibold tracking-tight text-ink" data-id="element-196" data-mp="20vaxkmsmiyqy">
                Misión
              </h3>
              <div className="mt-5 space-y-5 text-base leading-relaxed text-ink-soft" data-id="element-197" data-mp="1s3inid7ihrmw">
                <p data-id="element-198" data-mp="1s15zbib5ul1e">
                  Nuestra misión es mejorar la vida de las personas brindándoles acceso a productos y
                  soluciones que hagan realidad sus proyectos, con opciones de compra accesibles,
                  financiación y una atención cercana y confiable.
                </p>
                <p data-id="element-199" data-mp="194mwtbuv3vdt">
                  Trabajamos para construir una empresa que genere oportunidades para nuestros
                  clientes, nuestros colaboradores y nuestra comunidad, creciendo de manera
                  responsable, innovando constantemente y manteniendo siempre la cercanía y el
                  compromiso que nos caracteriza.
                </p>
                <p className="text-ink font-medium" data-id="element-200" data-mp="315bzn3izl3yl">
                  Queremos que cada persona que nos elige sienta que no solamente está comprando un
                  producto, sino que está encontrando una empresa que la acompaña a cumplir sus
                  proyectos.
                </p>
              </div>
            </article>
          </Reveal>

          <Reveal delay={0.15} data-id="element-201" data-mp="3ks9kx4vsfm2r">
            <article className="h-full rounded-4xl border border-black/5 bg-white p-8 sm:p-10 shadow-soft" data-id="element-202" data-mp="3krgp2yydagze">
              <span className="inline-flex h-14 w-14 items-center justify-center rounded-2xl border border-brand/25 bg-brand-light text-brand" data-id="element-203" data-mp="3ftotnuyikcqg">
                <TelescopeIcon className="h-7 w-7" strokeWidth={1.25} aria-hidden="true" data-id="element-204" data-mp="363lt99p2bwi3" />
              </span>
              <h3 className="mt-7 text-2xl sm:text-3xl font-semibold tracking-tight text-ink" data-id="element-205" data-mp="7dd93xba3iqx">
                Visión
              </h3>
              <div className="mt-5 space-y-5 text-base leading-relaxed text-ink-soft" data-id="element-206" data-mp="2l29kvkg9yyw">
                <p data-id="element-207" data-mp="9z2tpwpgnm9s">
                  Construir una de las empresas más importantes y confiables de nuestra región, con
                  presencia en diferentes mercados y capacidad para generar oportunidades para miles
                  de personas.
                </p>
                <p data-id="element-208" data-mp="ov2b5xygmyrl">
                  Queremos crecer sin perder nuestra esencia: la cercanía, la confianza y el
                  compromiso con nuestros clientes y nuestra gente.
                </p>
                <p className="text-ink font-medium" data-id="element-209" data-mp="xup2fqxh6o6x">
                  Queremos crear una organización profesional, innovadora y sostenible, que
                  trascienda a sus fundadores y se convierta en un proyecto empresarial que continúe
                  creciendo y generando valor durante generaciones.
                </p>
              </div>
            </article>
          </Reveal>

          <Reveal delay={0.25} className="lg:col-span-2" data-id="element-210" data-mp="1gl6t7pyqz9pn">
            <article className="h-full rounded-4xl border border-black/5 bg-white p-8 sm:p-10 shadow-soft" data-id="element-211" data-mp="1gjly9z8itor9">
              <span className="inline-flex h-14 w-14 items-center justify-center rounded-2xl border border-brand/25 bg-brand-light text-brand" data-id="element-212" data-mp="29brqi2f1edcf">
                <GemIcon className="h-7 w-7" strokeWidth={1.25} aria-hidden="true" data-id="element-213" data-mp="2n23k65r9sk5o" />
              </span>
              <h3 className="mt-7 text-2xl sm:text-3xl font-semibold tracking-tight text-ink" data-id="element-214" data-mp="2j2ur73420qb6">
                Valores
              </h3>
              <ul className="mt-6 flex flex-wrap gap-2" data-id="element-215" data-mp="1vdtozxltebec">
                {VALUES.map(value => <li key={value} className="rounded-full border border-black/10 bg-haze px-4 py-2 text-sm font-medium text-ink-soft transition-colors duration-300 hover:border-brand hover:bg-brand-light hover:text-brand" data-id="element-216" data-mp="1qf8py1iatxrh">
                    {value}
                  </li>)}
              </ul>
            </article>
          </Reveal>
        </div>
      </div>
    </section>;
}